import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'fontsource-roboto';
import Provider from './Provider';
import './lib.r2/utils/Globals';


const container = document.getElementById('root');
const root = ReactDOM.createRoot(container); 	// createRoot(container!) if you use TypeScript
root.render(<Provider>
	<App />
</Provider>);


const addBtn = document.querySelector('.add-button');
addBtn.style.display = 'none';


const onUpdate = async reg => {
	// serviceWorker.unregister();		//clear cache and reload

	alert('Update detected! Click OK to restart now');

	localStorage.clear()
	// sessionStorage.clear()	//keep login data

	let dbs = await window.indexedDB?.databases()
	dbs?.forEach(async db => {
		console.log('delete indexDb ' + db.name, '...')
		window.indexedDB.deleteDatabase(db.name)
	})

	const keys = await caches.keys();
	keys.map(async (cache) => {
		if(cache !== 'v2') {
			console.log('Service Worker: Removing old cache: ' + cache);
			return await caches.delete(cache);
		}
	})

	global.serviceWorker?.unregister();		//clear cache and reload

	console.log('OK')

	setTimeout(() => {
		window.location.reload(true); 

	}, 1000)
}


global.serviceWorker = serviceWorker
serviceWorker.register({onUpdate});
